module.exports = __webpack_public_path__ + "img/SMT_19_Mr_Henry_Kang.c53f5d83.jpg";